// 앞 글자의 받침 유무에 따라 조사를 고른다.
// 번역 문구에 {을를} {이가} {은는} {와과} 형태로 넣어두면 applyJosa 가 바꿔준다.

// [받침 있을 때, 받침 없을 때]
const JOSA = {
  '을를': ['을', '를'],
  '이가': ['이', '가'],
  '은는': ['은', '는'],
  '와과': ['과', '와']
}

// 한글 음절(가 ~ 힣)인지, 받침이 있는지 판단한다
function hasBatchim(char) {
  const code = char.charCodeAt(0)

  if (code < 0xac00 || code > 0xd7a3) {
    // 한글이 아니면(영문, 숫자 등) 받침 없는 쪽을 쓴다
    return false
  }

  return (code - 0xac00) % 28 !== 0
}

function applyJosa(text) {
  if (!text) {
    return text
  }

  return text.replace(/(.)\{(을를|이가|은는|와과)\}/g, (match, prev, token) => {
    const [withBatchim, withoutBatchim] = JOSA[token]

    return prev + (hasBatchim(prev) ? withBatchim : withoutBatchim)
  })
}

export { applyJosa }
